/* eslint-disable */

import LogoOS from 'src/assets/brand/Logo OS Assist white.svg'
import LogoLDA from 'src/assets/brand/2024-lda-logo-white.png'
import LogoMohrSiebeck from 'src/assets/brand/logo_mohrsiebeck.png'
import LogoRehm from 'src/assets/brand/logo rehm.svg'
import LogoReguvis from 'src/assets/brand/logo reguvis.svg'
import LogoErichSchmidt from 'src/assets/brand/logo_erichschmidt_white.svg'
//import LogoNKR from 'src/assets/brand/logo_bayerischernkr_transparent.png'
import LogoNKR from 'src/assets/brand/Logo_NKR_Homepage_bg_removed_v2.png'
import LogoLindeVerlag from 'src/assets/brand/260728 LindeVerlagLogo white.png'
import LogoStaempfli from 'src/assets/brand/Logo_Stämpfli_Gruppe_conv.svg'

export const THEMES = {
  LDA_LIGHT: 'LDA',
  LDA_DARK: 'Dark',
  OTTO_SCHMIDT: 'Light',
  MOHR_SIEBECK: 'MS',
  REGUVIS: 'REGUVIS',
  NKR: 'NKR',
  REHM: 'REHM',
  LINDE: 'LINDE',
  STAEMPFLI: 'STAEMPFLI',
  ERICH_SCHMIDT: 'ERICHSCHMIDT',
};


export const LOGOS = {
  Light: LogoOS,
  Dark: LogoOS,
  LDA: LogoLDA,
  MS: LogoMohrSiebeck,
  NKR: LogoNKR,
  LDAImgWhite: LogoLDA,
  REHM: LogoRehm,
  REGUVIS: LogoReguvis,
  ERICHSCHMIDT: LogoErichSchmidt,
  LINDE: LogoLindeVerlag,
  STAEMPFLI: LogoStaempfli,
}

export const THEME_SWATCHES = {
  [THEMES.OTTO_SCHMIDT]: '#135fa1',
  [THEMES.LDA_DARK]: 'linear-gradient(135deg, #1f2937 0 50%, #135fa1 50% 100%)',
  [THEMES.LDA_LIGHT]: '#6f1281',
  [THEMES.MOHR_SIEBECK]: '#24418f',
  [THEMES.NKR]: '#0093d4',
  [THEMES.REHM]: '#ec6608',
  [THEMES.REGUVIS]: '#cc0935',
  [THEMES.LINDE]: '#1e387b',
  [THEMES.STAEMPFLI]: '#1405be',
  [THEMES.ERICH_SCHMIDT]: '#004e9e',
}
